import {
  FC,
  JSX,
  ReactNode
} from "react";
import { View, Text } from "react-native";
import Skeleton from "@/app/components/Skeleton";

export type InfoBlockType = {
  label: string;
  value?: string | ReactNode;
};

export type InfoBlockProps = {
  rows: InfoBlockType[];
  withBlock?: boolean;
  isLoading?: boolean;
};


const InfoBlock: FC<InfoBlockProps> = ({
  rows,
  withBlock = true,
  isLoading = false
}): JSX.Element => {

  const content = rows.map(({ label, value }, i) => {
   
    const displayValue = (() => {
      if (value === null || value === undefined) return "Информация отсутствует";
      if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") return String(value);
      
      if (typeof value === "object" && "$$typeof" in value) return value;
      
      if (typeof value === "object") {
        if (Array.isArray(value)) return value.length > 0 ? `Найдено записей: ${value.length}` : "Информация отсутствует";
        return "Информация отсутствует";
      }
      return String(value);
    })();

    return (
      <View key={i} className="mb-4">
        <Text className="text-gray text-base mb-1">{label}</Text>
        {isLoading
          ? <Skeleton />
          : typeof displayValue === "object" && "$$typeof" in displayValue
            ? displayValue
            : <Text className="text-base text-black">{displayValue}</Text>}
      </View>
    );
  });

  //TODO: добавить стили для физ.лица
  return withBlock ? <View>{content}</View> : <View>{content}</View>;
};

export default InfoBlock;
